import * as GSU from '@getsetup/embed';
import dlv from 'dlv';

/**
 * @readonly
 * @enum {string}
 */
export const NAVIGATION_ACTION = {
	discover: 'discover',
	learn: 'learn',
	fitness: 'fitness',
	class: 'class',
	joinclass: 'joinClass',
	login: 'login',
	home: 'home',
	help: 'help'
};

export const createGsuIframeInstance = (props, state) => {
	// this is passed to us from the backend and is derived from the current URL
	let targetPage = props.getSetUpTargetPage;

	// For GSU's new customized pages we need to take the older
	// targetPage which our backend sends us and replace it with the
	// newer version
	if (dlv(state, 'pageConfig.gsuConfig.enableNewPages')) {
		switch (targetPage) {
			case  NAVIGATION_ACTION.learn:
				targetPage = NAVIGATION_ACTION.discover;
				break;
			case NAVIGATION_ACTION.joinclass:
				targetPage = NAVIGATION_ACTION.class;
				break;
		}
	}
	
	// See GetSetUp's documentation for more information about these options
	return GSU.createIframe({
		targetElementId: 'getSetUpEmbedTarget',
		targetPage,
		embeddingOrgId: dlv(state, 'pageConfig.gsuConfig.embeddingOrgId'),
		disableChat: true,
		disableHelp: true,
		navigationCallBack: navigationListener,
		classSlug: props.getSetUpClassSlug, // class slug (human readable id), otherwise undefined
		sessionId: props.getSetUpSessionId, // class session id from the joinClass url, otherwise undefined
		linkTemplates: {
			joinClass: `https://${window.location.hostname}/onlineclass/watch/{classSlug}/{sessionId}`,
			learnPage: `https://${window.location.hostname}/onlineclass`
		},
		targetUrls: dlv(state, 'pageConfig.gsuConfig.targetUrls'),
		analyticsInfo: {
			domain: window.location.host
		}
	});
};

/**
 * @param {NAVIGATION_ACTION} navigationAction
 * @param {string} [sessionId]
 * @param {string} [classSlug]
 */
export const navigationListener = (navigationData) => {
	const { navigationAction, sessionId, classSlug } = navigationData;
	const url = new URL(window.location.origin);
	switch (navigationAction) {
		case NAVIGATION_ACTION.discover:
			return;
		case NAVIGATION_ACTION.learn:
			url.pathname = '/onlineclass';
			window.location.href = url.toString();
			return;
		case NAVIGATION_ACTION.class:
			return;
		case NAVIGATION_ACTION.joinclass:
			url.pathname = `/onlineclass/watch`;
			if (classSlug && sessionId) {
				url.pathname = `/onlineclass/watch/${encodeURIComponent(classSlug)}/${encodeURIComponent(sessionId)}`;
			}
			else if (classSlug) {
				url.pathname = `/onlineclass/watch/${encodeURIComponent(classSlug)}`;
			}
			else {
				throw new Error('Navigation to a class page requested without a session id or class slug');
			}
			window.location.href = url.toString();
			return;
		case NAVIGATION_ACTION.login:
			// we don't need to implement this because we've set `disableChat` to false
			return;
		case NAVIGATION_ACTION.home:
			// navigate to the portal homepage
			url.pathname = '/';
			window.location.href = url.toString();
			return;
		case NAVIGATION_ACTION.help:
			// we don't need to implement this because we've set `disableHelp` to false
			return;
		default:
			url.pathname = `/onlineclass/category/${encodeURIComponent(
				navigationAction
			)}`;
			window.location.href = url.toString();
			return;
	}
};
